module.exports = __webpack_public_path__ + "img/beard-2.7496ff72.svg";